import {
  IDriveViewTrashedFolder,
  IDriveViewTrashedPlacement,
} from '@commenda/types/src/drive-view/types';
import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface ITrashedFolderContentsResponse {
  folders: IDriveViewTrashedFolder[];
  placements: IDriveViewTrashedPlacement[];
}

export async function getTrashedFolderContents({
  folderId,
}: {
  folderId: string;
}): Promise<IApiResponse<ITrashedFolderContentsResponse>> {
  const response = await fetcher(`drive-view/folder/${folderId}/trash-contents`, {
    method: 'GET',
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to get trashed folder contents',
      statusCode: response.status,
      data: null,
    };
  }

  const body: ITrashedFolderContentsResponse = await response.json();
  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: body,
  };
}
